import React, { useContext } from "react";
import styled from "styled-components";
import {
  errorStrong,
  reviewDark,
  distributeDark,
  appealDark,
} from "../styles/colors";
import { ColorContext } from "./Bootstrap";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

const ButtonElement = styled.button`
  color: #fff;

  ${(props) =>
    props.type === "" || !props.type
      ? `background-color: ${props.mainColor};`
      : ``}
  ${(props) =>
    props.type === "danger" ? `background-color: ${errorStrong};` : ``}
  
 
    ${(props) =>
    props.type === "review" ? `background-color: ${reviewDark};` : ``}
    ${(props) =>
    props.type === "distribute" ? `background-color: ${distributeDark};` : ``}
      ${(props) =>
    props.type === "appeal" ? `background-color: ${appealDark};` : ``}
  align-items: center;
  justify-content: center;
  min-height: 42px;
  padding: 11px 22px;
  text-align: center;
  font-family: Blinker;
  font-weight: 700;
  ${(props) => (props.noFullWidth ? "width: auto;" : "width: 100%;")}
  background-image: none;
  border: none;
  font-size: 17px;
  line-height: 20px;
  border-radius: 8px;
  box-shadow: 0 8px 18px rgba(6, 40, 59, 0.14);
  cursor: pointer;
  display: inline-flex;
  gap: 8px;
  letter-spacing: 0.1px;
  transition: opacity 120ms ease-in, transform 120ms ease-in,
    box-shadow 120ms ease-in;

  ${(props) =>
    props.size === "reduced"
      ? `font-size: 15px;padding: 7px 12px;min-height: 34px;`
      : ``}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0 10px 22px rgba(6, 40, 59, 0.18);
  }

  &:focus {
    outline: 3px solid rgba(9, 191, 165, 0.22);
    outline-offset: 2px;
  }

  .loader {
    display: inline !important;
    margin-right: 5px;
    margin-top: 2px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const ActionButton = styled.button`
  ${(props) => `background-color: ${props.mainColor};`}

  border-radius: 8px;
  background-image: none;
  border: none;
  font-size: 17px;
  padding: 11px 22px;
  min-height: 42px;
  line-height: 20px;
  color: #fff;
  font-family: Blinker;
  font-weight: 700;
  transition: opacity 120ms ease-in, transform 120ms ease-in,
    box-shadow 120ms ease-in;
  outline: none;
  box-shadow: 0 8px 18px rgba(6, 40, 59, 0.14);
  cursor: pointer;

  ${(props) =>
    props.type === "" || !props.type
      ? `background-color: ${props.mainColor};`
      : ``}
  ${(props) =>
    props.type === "danger" ? `background-color: ${errorStrong};` : ``}
  
  ${(props) =>
    props.size === "reduced"
      ? `font-size: 15px;padding: 7px 12px;min-height: 34px;`
      : ``}
  
    ${(props) =>
    props.type === "review" ? `background-color: ${reviewDark};` : ``}
    ${(props) =>
    props.type === "distribute" ? `background-color: ${distributeDark};` : ``}
    ${(props) =>
    props.type === "appeal" ? `background-color: ${appealDark};` : ``}
  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0 10px 22px rgba(6, 40, 59, 0.18);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  &:focus {
    outline: 3px solid rgba(9, 191, 165, 0.22);
    outline-offset: 2px;
  }

  .loader {
    display: inline !important;
    margin-right: 5px;
    margin-top: 2px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

function Button(props) {
  const { loading, children, action = false, loadingText, ...buttonProps } = props;
  const mainColor = useContext(ColorContext);
  const content = !loading ? (
    children
  ) : (
    <span>
      <Loader
        type="TailSpin"
        color="#fff"
        height="20"
        width="20"
        className="loader"
        text={loadingText}
      />
      <span>{loadingText || "Please Wait"}</span>
    </span>
  );

  return action ? (
    <ActionButton
      {...buttonProps}
      disabled={loading || buttonProps.disabled}
      mainColor={mainColor}
    >
      {content}
    </ActionButton>
  ) : (
    <ButtonElement
      {...buttonProps}
      disabled={loading || buttonProps.disabled}
      mainColor={mainColor}
    >
      {content}
    </ButtonElement>
  );
}

Button.defaultProps = {
  componentType: "Button",
};

export default Button;
